const regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;     //邮箱
const regCN = /[\u4e00-\u9fa5]/;               //中文
const regPhone = /^[1][3-9][0-9]{9}$/; //手机
const regIdx = /^([0-9]){7,18}(x|X)?$|^\d{8,18}|[0-9x]{8,18}|[0-9X]{8,18}?$/;       //18带X身份证
const regId = /^\d{15}|\d{18}$/;                                //15位或者18位身份证
const regPass = /^[a-zA-Z]\w{5,17}$/;                               //以字母开头，长度在6~18之间，只能包含字母、数字和下划线
const regAccount = /^[a-zA-Z][a-zA-Z0-9_]{4,15}$/;                     //字母开头，允许5-16字节，允许字母数字下划线
const regQq = /[1-9][0-9]{4,}/;                                        //QQ号
const regPostCode = /[1-9]\d{5}(?!\d)/;                                //邮编
const regTel = /\d{3}-\d{8}|\d{4}-\d{7}/;
const regNum = /^[0-9]*$/;
const regNick = /^[\u4E00-\u9FA5A-Za-z0-9_]+$/;  // 中文、英文、数字包括下划线

export {
    regEmail,
    regCN,
    regPhone,
    regIdx,
    regTel,
    regId,
    regPass,
    regAccount,
    regQq,
    regPostCode,
    regNum,
    regNick
}